document.addEventListener("DOMContentLoaded", function () {
  function initRenderResults(type, classContainer) {
    if (document.querySelector(".search-panel")) {
      let q = document.querySelector(".search-panel").dataset.q;
      let urlFetch = `${window.routes.search_url}?type=${type}&q=${encodeURIComponent(q)}`;
      if (type == "collection") {
        urlFetch = `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&section_id=predictive-search-collections`;
      }
      fetch(urlFetch)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");
          const resultsGridFetch = doc.querySelector(classContainer);
          const countPagesFetch = doc.querySelector(
            "#search-type-pages .count",
          );
          const countCollectionsFetch = doc.querySelector(
            ".search-panel-result.search-type-collections",
          );

          const resultsGrid = document.querySelector(classContainer);
          const countPages = document.querySelector(
            "#search-type-pages .count",
          );
          const countCollections = document.querySelector(
            "#search-type-collections .count",
          );

          if (resultsGridFetch != null && resultsGrid != null) {
            resultsGrid.innerHTML = resultsGridFetch.innerHTML;
          }
          if (type == "page") {
            if (countPages != null && countPagesFetch != null) {
              countPages.textContent = countPagesFetch.textContent;
            }
          } else if (type == "collection") {
            if (countCollections != null && countCollectionsFetch != null) {
              countCollections.textContent =
                countCollectionsFetch.dataset.count;
            }
          }
        })
        .catch((error) => console.error("Fetch error:", error));
    }
  }
  function initSearchPage() {
    const searchPanel = document.querySelector(".search-panel");
    const urlTypeP = new URLSearchParams(window.location.search).get("type-p");
    if (searchPanel != null && urlTypeP != "") {
      function showPanel(id) {
        searchPanel.querySelectorAll(".search-panel__type").forEach((item) => {
          item.classList.remove("active");
        });
        searchPanel
          .querySelector("#" + id)
          .closest(".search-panel__type")
          .classList.add("active");

        document.querySelectorAll(".search-panel-result").forEach((item) => {
          item.classList.remove("active");
        });
        document.querySelector("." + id).classList.add("active");
      }
      if (urlTypeP == "product") {
        showPanel("search-type-products");
      } else if (urlTypeP == "collection") {
        showPanel("search-type-collections");
      } else if (urlTypeP == "page") {
        showPanel("search-type-pages");
      } else {
        showPanel("search-type-products");
      }
      searchPanel
        .querySelectorAll(".search-panel__type")
        .forEach(function (item) {
          item.addEventListener("click", function () {
            showPanel(item.firstElementChild.id);
          });
        });
    }
  }

  initSearchPage();
  initRenderResults(
    "collection",
    ".search-panel-result.search-type-collections",
  );
  initRenderResults("page", ".search-panel-result.search-type-pages");
});

document.addEventListener("DOMContentLoaded", function () {
  const delayTime = 30000;
  const storageKey = "newsletter_popup_shown_v1";

  const isShown = localStorage.getItem(storageKey);

  if (!isShown) {
    setTimeout(function () {
      document
        .querySelector(
          'button[data-src="#newLetterFormModalProfessionalAndBase"]',
        )
        .click();
      localStorage.setItem(storageKey, "true");
    }, delayTime);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  //AejZYSUYrS2ZtYnFPV__forms_inline_iHgTx9 - dev
  const containerId = "AWUJ4RDRieTM2bFBRW__forms_inline_iHgTx9";

  async function forceInit() {
    const container = document.getElementById(containerId);
    if (!container) return;

    await new Promise((r) => setTimeout(r, 2000));

    let embed = container.querySelector("shopify-forms-embed");

    if (!window.ShopifyForms) {
      console.log("API missing. Forcing shopify-forms-loader script...");
      const loader = document.createElement("script");
      loader.src =
        "https://cdn.shopify.com/extensions/cb5b2fb5-f3ac-42c5-97b1-22254faacc63/forms-2347/assets/shopify-forms-loader.js";
      document.head.appendChild(loader);
    }

    if (embed && !embed.shadowRoot) {
      console.log("Form found but empty. Re-mounting...");
      const clone = embed.cloneNode(true);
      embed.replaceWith(clone);
      triggerOfficialInit(1000);
    } else if (!embed) {
      console.log("Embed missing. Forcing official initialization...");

      triggerOfficialInit(0);

      setTimeout(() => {
        if (!container.querySelector("shopify-forms-embed")) {
          console.log(
            "Official init failed to produce tag. Manual injection...",
          );
          const manualEmbed = document.createElement("shopify-forms-embed");
          manualEmbed.id = "app-embed";
          manualEmbed.style.display = "block";
          container.appendChild(manualEmbed);

          triggerOfficialInit(500);
        }
      }, 1500);
    } else {
      console.log("Embed exists and initialized.");
    }
  }

  function triggerOfficialInit(delay) {
    setTimeout(() => {
      if (window.ShopifyForms && window.ShopifyForms.initialize) {
        window.ShopifyForms.initialize();
        console.log("ShopifyForms.initialize() executed.");
      }
    }, delay);
  }

  forceInit();

  function checkNewsletterForm() {
    const formModal = document.getElementById(
      "newLetterFormModalProfessionalAndBase",
    );
    if (!formModal) return;
    const toggle = formModal.querySelector(".toggle-show-additional-form");
    const mailchimpTagsInput = formModal.querySelector(
      "#mailchimp_custom_tags",
    );
    toggle.addEventListener("change", (e) => {
      if (e.target.checked) {
        if (mailchimpTagsInput) mailchimpTagsInput.value = "professional";
      } else {
        if (mailchimpTagsInput) mailchimpTagsInput.value = "newsletter";
      }
    });
  }

  checkNewsletterForm();
});
